import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AssetStateService} from '../asset/asset-state.service';
import {ImageAsset} from '../../model/typings/asset.types';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class AssetService {
  imageAssetsForViewApiUrl = 'api/view-assets';

  constructor(private http: HttpClient,
              private assetStateService: AssetStateService) {

  }

  // TODO?: Add caching/storage strategy to limit api calls to a defined interval (once per new calendar day?)

  getImageAssetsForView(options: { viewId: string, updateState: boolean }): Observable<any> {
    const params = {};
    const imageAssetsForViewUrl = `${environment.resourceServer + this.imageAssetsForViewApiUrl}/${options.viewId}`;

    console.log(`CPUI - AssetService.getImageAssetsForView()`, options, imageAssetsForViewUrl);

    if (options.updateState) {
      return this.http.get<any>(imageAssetsForViewUrl,
        {params, withCredentials: true})
        .map((response) => this.updateImageAssetsForViewInState(response));
    } else {
      return this.http.get<Object>(imageAssetsForViewUrl,
        {params, withCredentials: true})
        .map((response) => this.handleImageAssetsForViewResponse(response));
    }
  }

  private handleImageAssetsForViewResponse(response: any): ImageAsset[] {
    console.log(`CPUI - AssetService.handleImageAssetsForViewResponse()`);
    return response.imageAssets;
  }

  private updateImageAssetsForViewInState(response: any): ImageAsset[] {
    console.log(`CPUI - AssetService.updateImageAssetsForViewInState()`);
    return this.assetStateService.updateImageAssetsForView(response.imageAssets);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/asset/asset.service.ts